import { DEFAULT_LATEST } from 'constants/dateLimits';
import { ValidateJSModel } from 'forms/shared/types/validatejs';
import { setToStartOfMonth } from 'helpers/date';
import { checkValueIncluded } from 'models/validate';
import { OTHER } from 'constants/enums/legalOptions';
import { LEGAL_INVESTIGATIONS_PIV_ISSUES } from 'constants/sections';
import { isPVQForm } from 'helpers/form';
import pvqInvestigatingAgency from 'forms/shared/validators/models/pvqInvestigatingAgency/pvqInvestigatingAgency';
import { LegalInvestigationsDeniedItemModel, LegalInvestigationsSuspendedItemModel } from '../types';

export const legalInvestigationsDeniedItemValidator: ValidateJSModel<LegalInvestigationsDeniedItemModel> = {
  Date: (value, attributes, attributeName, options = {}) => {
    if (attributes?.DateNotApplicable?.applicable === false) {
      return {};
    }

    const { applicantBirthdate } = options;

    return {
      presence: true,
      date: { earliest: setToStartOfMonth(applicantBirthdate), latest: DEFAULT_LATEST },
    };
  },
  DateNotApplicable: {},
  Agency: (value, attributes, attributeName, options) => {
    if (attributes?.AgencyNotApplicable?.applicable === false) {
      return {};
    }

    return { presence: true, model: { validator: pvqInvestigatingAgency } };
  },
  AgencyExplanation: (value, attributes) => {
    if (checkValueIncluded(attributes?.Agency, [OTHER])) {
      return { presence: true, hasValue: true };
    }

    return {};
  },
  AgencyNotApplicable: {},
  Explanation: { presence: true, hasValue: true },
};

export const legalInvestigationsSuspendedItemValidator: ValidateJSModel<LegalInvestigationsSuspendedItemModel> = {
  Agency: (value, attributes, attributeName, options) => {
    if (attributes?.AgencyNotApplicable?.applicable === false) {
      return {};
    }

    return { presence: true, model: { validator: pvqInvestigatingAgency } };
  },
  AgencyExplanation: (value, attributes) => {
    if (checkValueIncluded(attributes?.Agency, [OTHER])) {
      return { presence: true, hasValue: true };
    }

    return {};
  },
  AgencyNotApplicable: {},
  Date: (value, attributes, attributeName, options = {}) => {
    if (attributes?.DateNotApplicable?.applicable === false) {
      return {};
    }

    const { applicantBirthdate } = options;

    return {
      presence: true,
      date: { earliest: setToStartOfMonth(applicantBirthdate), latest: DEFAULT_LATEST },
    };
  },
  DateNotApplicable: {},
  Outcome: (value, attributes) => ({ presence: true, hasValue: true }),
  OutcomeExplanation: (value, attributes) => {
    if (checkValueIncluded(attributes?.Outcome, [OTHER])) {
      return { presence: true, hasValue: true };
    }

    return {};
  },
  Explanation: { presence: true, hasValue: true },
  ReinstatedDate: (value, attributes, attributeName, options = {}) => {
    if (options?.subsectionKey === LEGAL_INVESTIGATIONS_PIV_ISSUES && checkValueIncluded(attributes?.Outcome, ['Reinstated']) && attributes?.ReinstatedDateNotApplicable?.applicable === true) {
      const { applicantBirthdate } = options;

      return {
        presence: true,
        date: { earliest: setToStartOfMonth(applicantBirthdate), latest: DEFAULT_LATEST },
      };
    }

    return {};
  },
  ReinstatedDateNotApplicable: {},
};
